// Samlet varselstrøm: komponerer ALLE varsel-motorene til ÉN prioritert, dempet
// kø som operatør-panelet (COP) rendrer. Én inngang inn, én sortert liste ut —
// slik at HVT/TST, nærhet, hurtigmål, bevegelses-/samband-avvik og OSINT-
// nøkkelord havner i samme «innboks», verste først. Ren + testbar; selve
// data-innhentingen (tracks/noder/strøm) gjøres av kalleren.
import { prioritizeAlerts, dedupeAlerts, proximityAlerts, fastMoverAlerts, targetPriorityAlerts, sensorObservasjonAlerts, uposisjonertKontaktAlerts } from './alerts.js';
import { movementAnomalies, commsAnomalies } from './anomaly.js';
import { keywordAlerts } from './keywordwatch.js';
/**
 * Bygg den samlede, prioriterte og dempede varselstrømmen fra alle kildene.
 * Rekkefølge: kritisk→advarsel→info, nyeste først innen nivå.
 */
export function buildAlertFeed(input, opts = {}) {
    const all = [];
    if (input.targets?.length)
        all.push(...targetPriorityAlerts(input.targets));
    if (input.tracks?.length && input.guarded?.length) {
        all.push(...proximityAlerts(input.tracks, input.guarded, input.proximityRadiusM ?? 1000));
    }
    if (input.speeds?.length)
        all.push(...fastMoverAlerts(input.speeds, input.fastThresholdMps));
    for (const m of input.movement ?? [])
        all.push(...movementAnomalies(m.refId, m.label, m.history));
    if (input.comms?.length)
        all.push(...commsAnomalies(input.comms, input.nowMs));
    if (input.stream?.length && input.watchTerms?.length)
        all.push(...keywordAlerts(input.stream, input.watchTerms));
    // Ferske retningsbestemte observasjoner (feltbilde, Frigate, PTZ, peiling).
    // Ingen egen inngang: regelen leser `siktsektor` av sporene vi alt har, så den
    // gjelder automatisk for hver ny sensortype som får en sektor.
    if (input.tracks?.length)
        all.push(...sensorObservasjonAlerts(input.tracks, input.nowMs, input.sensorVinduMs));
    // Uposisjonerte deteksjoner (VALE SENS-21) — samme ferskhetsvindu som
    // sensorObservasjonAlerts, egen regel fordi disse aldri har en `bearingDeg`.
    if (input.sporUtenPosisjon?.length) {
        all.push(...uposisjonertKontaktAlerts(input.sporUtenPosisjon, input.nowMs, input.sensorVinduMs));
    }
    const fresh = opts.seen ? dedupeAlerts(all, opts.seen, opts.dedupeWindowMs) : all;
    const ranked = prioritizeAlerts(fresh);
    return opts.limit !== undefined ? ranked.slice(0, opts.limit) : ranked;
}
/** Tell varsler per alvorsgrad (til badge på panel-fanen). */
export function alertCounts(alerts) {
    const c = { kritisk: 0, advarsel: 0, info: 0 };
    for (const a of alerts)
        c[a.severity]++;
    return c;
}
//# sourceMappingURL=alertfeed.js.map